import { DefaultPathEnum } from '../../main/constants/default-path.ts';
import { RootState } from '../../main/store/main.store.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectHasProfile } from './has-profile.selector.ts';

export const selectProfileRedirectionPath = createMemoizedSelector(
  selectHasProfile,
  (state: RootState) => state.accounts.shouldSeeBeginJourney,
  (hasProfile, shouldSeeBeginJourney): DefaultPathEnum | null => {
    if (!hasProfile) {
      return DefaultPathEnum.ACCOUNTS_CREATE_PROFILE;
    }

    if (shouldSeeBeginJourney) {
      return DefaultPathEnum.ACCOUNTS_BEGIN_JOURNEY;
    }

    return null;
  }
);
